module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_borlange-43eae930498a593abcbfa5471b72f41f.png";